import React from 'react';
import { observer } from 'mobx-react';
import { ProcedureCodeListTemplate } from 'themes/application/procedure-code/pages';
import { setCurrentView } from 'core/utils';
import { ProcedureCodeListViewStore } from 'application/procedure-code/stores';

@setCurrentView((rootStore) => new ProcedureCodeListViewStore(rootStore), 'procedureCodeListViewStore')
@observer
class ProcedureCodeList extends React.Component {
    render() {
        return <ProcedureCodeListTemplate {...this.props} />
    }
}

export default ProcedureCodeList;